const strings = {
	"navigation": {
		"next": "Next",
		"previous": "Previous",
    	"see": "See My",
		"me": "About Me",
		"work": "Professional Experience",
		"education": "Education",
		"skills": "Skills",
		"contact": {
			"text": "Get In Touch",
			"alt": "Here are some methods of contacting me",
			"image": "/contact5.png"
		},
	},
	"content": {
		"name": "Emir Gökhan ÖZÇELİK",
		"myphoto": {
			"image": '/MyPhoto.png',
			"alt": "my photo"
		},
		"title": "Full-Stack Developer",
		"personal": "33 years old, Turkish, located in Toulouse, France, relocation possible to anywhere in the World",
		"missionTitle": "Mission",
    	"aboutMePointMarker": '/check.png',
		"aboutMePoints": [
			"33-year-old full stack-oriented developer passionate about his work with <strong>4 years of experience in developing applications</strong> after 12 years of experience in English, French and Turkish translation industry",
			"Fueled by job ownership and company citizenship, <strong>takes initiative to bring new ideas to the table</strong> with collective success in mind",
			"Thrives with <strong>learning and problem-solving challenges</strong> and follows state-of-the-art techniques and technologies to build systems to be proud of",
			"Looking for new career opportunities with a larger space to evolve and <strong>make a change for the better</strong> anywhere in the world"
		],
		"workexperience": "Professional Experience",
		"education": "Education",
		"softskills": "Main Soft Skills",
		"hardskills": "Main Hard Skills",
		"hobbies": "Hobbies",
		"timelineperiodstartindicator": " from ",
		"timelineperiodendindicator": " to ",
		"subdetailsheader": "Highlights:",
		"contactmethods": [
			{
				"logo": "/phone.png",
				"alt": "my telepĥone",
        "noUserInputText": "<a class='inline-block w-full' href='tel:+33603240059'>(0033) 603240059</a>"
			},
			{
				"logo": "/mail.png",
				"alt": "my e-mail",
				"noUserInputText": "<a class='inline-block w-full' target='_blank' href='mailto:emirgokhanozcelik@gmail.com'>emirgokhanozcelik@gmail.com</a>"
			},
			{
				"logo": "/website.png",
				"alt": "my website",
				"noUserInputText": "<a class='inline-block w-full' target='_blank' href='https://www.emirdev.com'>emirdev.com</a>"
			},
			{
				"logo": "/in.png",
				"alt": "my linkedin profile",
				"noUserInputText": "<a class='inline-block w-full' target='_blank' href='https://linkedin.com/in/emirozcelik'>/emirozcelik</a>"
			},
			{
				"logo": "/github.png",
				"alt": "my github",
				"noUserInputText": "<a class='inline-block w-full' target='_blank' href='https://github.com/animyrch'>/animyrch</a>"
			},
			{
				"logo": "/download.png",
				"alt": "Download this as CV",
				"noUserInputText": "<a class='inline-block w-full' target='_blank' href='/EmirOZCELIK-CV.pdf' download>Download this as CV</a>"
			},
		],
		"positions": [
			{
				"start": "2020-05",
				"end": "present",
				"title": "Full-Stack Application Developer, Junior at Lodecom, Saint-Sulpice/France",
				"subdetails": [
					{
						"noUserInputText": "Leading company efforts in completely rethinking their public reservation Web application as a fully responsive SaaS SPA"
					},
					{
						"noUserInputText": "Skills used in this position: Vue.js, Less, ElementUI, AdobeXD, Draw.io (for design diagrams), Node.js, Typescript, Sequilize, BDD, TDD (Vue-test-utils on the frontend and Mocha, Chai on the backend), git and Gitlab CD/CI"
					},
				]
			},
			{
				"start": "2018-09",
				"end": "2020-04",
				"title": "Full-Stack Application Developer (Internship) at Lodecom, Saint-Sulpice/France",
				"subdetails": [
					{
            			"noUserInputText": "Came up with and accomplished internal automation Web applications, <strong>doubling production team efficiency </strong>over the course of a 6-month period"
					},
					{
            			"noUserInputText": "Skills used in this position: HTML, Smarty, CSS, Vue.js, jQuery, Php, MySQL with PDO and TDD (with PhpUnit on the backend and QUnit on the frontend)"
					},
					{
						"noUserInputText": "Generated new ideas for the new public reservation mobile application by learning Flutter in 2 weeks and building proof-of- concept Android and IOS applications in another 2 weeks"
					},
					{
						"noUserInputText": "Collaborated with other developers to quickly debug and fix production issues in various applications of the company"
					}
				]
			},
			{
				"start": "2018-01",
				"end": "2018-05",
				"title": "Customer Service Executive at Booking.com, Lille/France",
						"subdetails": []
			},
			{
				"start": "2016",
				"end": "present",
				"title": "Personal Projects",
				"subdetails": [
          {
            "noUserInputText": "Developed and deployed this responsive CV App with <span class='italic'>React</span>, <span class='italic'>TailwindCSS</span> and <span class='italic'>Heroku CLI</span> (<a target='_blank' href='https://github.com/animyrch/CV' class='underline'>see on Github</a>)"
          },
          {
            "noUserInputText": "Participated in hackathons <a class='underline' href='https://www.nuitdelinfo.com/' target='_blank'>Nuit de l'Info</a> and <a target='_blank' class='underline' href='https://2019.devfesttoulouse.fr/'>in developer conferences</a>"
          },
					{
            			"noUserInputText": "Started the Turkish version of the official <span class='italic underline'><a target='_blank' href='https://animyrch.github.io/tr.vuejs.org/'>Vue.js Documentation Website</a></span>"
					},
					{
            			"noUserInputText": "Self-taught, designed, built and deployed a basic interactive Web app with several game modules for teaching vocabulary in <span class='italic'>Html, CSS, JQuery, Php</span> and <span class='italic'>Mysql</span> (hosted at <a target='_blank' href='http://traductionturcfrancais.com' class='underline'>traductionturcfrancais.com</a>)"
					},
					{
						"noUserInputText": "Self-taught, designed, built and deployed two basic <span class='italic'>Android</span> apps, one for teaching phonetics and another one for teaching grammar."
					}
				]
			},
      {
        "start": "2013-05",
        "end": "2013-08",
        "title": "Translator and Assistant Market Manager (Intership) at Ceetiz.com, Paris/France",
				"subdetails": []
      },
      {
        "start": "2012-10",
        "end": "2013-05",
        "title": "Teacher in Turkish Conversation Course at Strasbourg University, Strasbourg/France",
        "subdetails": []
      },
      {
        "start": "2009-05",
        "end": "2011-09",
        "title": "Assistant Project Manager in Translation at Bordo Tercume, Ankara/Turkey",
				"subdetails": []
      },
			{
				"start": "2006",
				"end": "2018",
				"title": "Translator & Interpreter in Turkish, French and English",
				"subdetails": []
			},
      {
        "start": "2005-11",
        "end": "2007-03",
        "title": "Supervisor at Burger King, Ankara/Turkey",
        "subdetails": []
      }
		],
		"degrees": [
			{
				"start": "2018",
				"end": "2020",
				"title": "Bachelor's Degree in Software Application Development - AP Formation, Toulouse/France",
				"subdetails": [
					{
            			"noUserInputText": "Lectures and projects in <span class='italic'>Javascript, Typescript, Angular 2, Agile Development and Application Design, MySQL, Php, CodeIgniter, Java SE, Java EE, Spring, Hibernate, Android</span> and <span class='italic'>Node.js</span>"
					},
					{
						"noUserInputText": "Term Project: Design choices and best practices for an internal database transfer application."
					}
				]
			},
			{
				"start": "2011",
				"end": "2013",
				"title": "Master's Degree in Linguistics and Translation - Strasbourg University, ITIRI, France",
				"subdetails": [
					{
						"noUserInputText": "Term Project : Linguistic analysis and translation of 'Turcs et Grecs : Entre Eris et Eros au tournant du siècle', a socio-political research book about Turkish-Greek relations."
					}
				]
			},
			{
				"start": "2004",
				"end": "2009",
				"title": "Bachelor's Degree in French Literature - Hacettepe University, Ankara/Turkey & Toulouse University - Mirail II, Toulouse/France",
				"subdetails": []
			},
      {
        "start": "2000",
        "end": "2004",
        "title": "High School Degree in Applied Foreign Languages (English, French) - Haydarpaşa Anatolian High School, Istanbul/Turkey",
        "subdetails": []
      }
		],
		"softskillslist": [
			{
				"noUserInputText": "Job ownership and company citizenship"
			},
			{
				"noUserInputText": "Strong desire for communication and collaboration"
			},
			{
				"noUserInputText": "Enthusiasm for analysis and problem-solving"
			},
			{
				"noUserInputText": "Ease of communication in written and oral forms in Turkish, French and English"
			}
		],
		"hardskillslist": [
			{
				"noUserInputText": "TDD (Front and Back)",
				"level": 80
			},
			{
				"noUserInputText": "Vue.js",
				"level": 70
			},
			{
				"noUserInputText": "Node.js",
				"level": 50
			},
			{
				"noUserInputText": "Php",
				"level": 90
			},
			{
				"noUserInputText": "Java",
				"level": 50
			},
			{
				"noUserInputText": "MySQL",
				"level": 90
			},
			{
				"noUserInputText": "Web MarkUp/Styling",
				"level": 80
			},
			{
				"noUserInputText": "Microsoft Office",
				"level": 90
			},
			{
				"noUserInputText": "Adobe XD",
				"level": 30
			},
			{
				"noUserInputText": "Visual Code Studio",
				"level": 90
			},
			{
				"noUserInputText": "IntelliJ/Android Studio",
				"level": 50
			},
			{
				"noUserInputText": "Draw.Io",
				"level": 60
			},
			{
				"noUserInputText": "Git/Gitlab/Github",
				"level": 60
			}
		],
		"hobbieslist": [
			{
				"name": "Gaming",
				"image": "/game.png"
			},
			{
				"name": "Literature",
				"image": "/book.png"
			},
			{
				"name": "Learning",
				"image": "/glasses.png"
			},
			{
				"name": "Coding",
				"image": "/code.png"
			}
		]
	}
}

export default strings;
